import React, { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import "bootstrap/dist/css/bootstrap.min.css";
// import "remixicon/fonts/remixicon.css";
import { gtmId } from "./constant/Config";
import AppMessage from "./constant/AppMessage";
import Loader from ".././Components/Common/CustomLoader";
import LandingJazzCashRoutes from "./routes";
// import "../styles/style.css";F
import { generateTokenPost } from "../Utils/FetchApi";
import ApiNames from "../Constants/ApiNames";
const LandingJazzCash = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [jwtToken, setJwtToken] = useState("");

  //initialize GTM
  const tagManagerArgs = {
    gtmId: gtmId,
  };
  TagManager.initialize(tagManagerArgs);

  //generate JWT token for JazzCash app
  useEffect(() => {
    generateToken();
  }, []);

  // const generateToken = async () => {
  //   try {
  //     console.log("Generating JWT token for JazzCash...");
  //     setIsLoading(true);
  //     let data = {
  //       username,
  //       password,
  //     };
  //     let response: IGenrateTokenResponse = await generateTokenService(data);
  //     if (response.result) {
  //       setJwtToken(response.result);
  //       global.authToken = response.result;
  //       setIsLoading(false);
  //     } else {
  //       console.log(AppMessage.initializationFailed);
  //     }
  //   } catch (e) {
  //     console.warn("Generate Token Error: ", e);
  //   }
  // };

  const generateToken = async () => {
    try {
      let response = await generateTokenPost(ApiNames.generateToken);
      console.log("response::", response);
      if (response.status === 200) {
        setIsLoading(false);
        setJwtToken(response.access_token);
        (window as any).authToken = response.access_token;
      } else {
        console.log("Authentication failed. Please try again.");
      }
    } catch (error) {
      console.warn("token authentication failed", error);
    }
  };
  // Render loader while generating token
  if (isLoading) {
    return <Loader />;
  }
  return <LandingJazzCashRoutes />;
};

export default LandingJazzCash;
